import { faAngleLeft, faAngleRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

export interface IBannerNavigatorProps {
    currentBanner: number
    setCurrentBanner: (banner: number) => void
    countBanners: number

}

const BannerNavigator = ({ currentBanner, setCurrentBanner, countBanners } : IBannerNavigatorProps) => (
    <div className="d-flex align-items-center">
        <FontAwesomeIcon
            className={classNames('mr-1', {
                'text-muted': currentBanner === 0,
                'cursor--pointer': currentBanner > 0,
            })}
            onClick={() => {
                if (currentBanner > 0) {
                    setCurrentBanner(currentBanner - 1);
                }
            }}
            icon={faAngleLeft}
            size="sm"
            data-testid="banner-navigator-left-arrow"
        />
        {` ${currentBanner + 1} of ${countBanners} `}
        <FontAwesomeIcon
            className={classNames('ml-1', {
                'text-muted': currentBanner === countBanners - 1,
                'cursor--pointer': currentBanner !== countBanners - 1,
            })}
            onClick={() => {
                if (currentBanner < countBanners - 1) {
                    setCurrentBanner(currentBanner + 1);
                }
            }}
            icon={faAngleRight}
            size="sm"
            data-testid="banner-navigator-right-arrow"
        />
    </div>
);

export default BannerNavigator;
